import { useCallback, useEffect, useState } from "react";
import "../leaveHistory.css";
import DashboardGreeting from "../DashboardGreeting";
import moment from "moment";
import { useLocation } from "react-router-dom";
import LeaveHistoryService from "../../services/leaveHistory.service";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import WarningIcon from "../../assets/images/warning.svg";

import { MdDelete } from "react-icons/md";

const LeaveReconcileDetails = ({ user }) => {
  const navHeading = "Leave Reconcile Details";
  const location = useLocation();
  const { rowData, redirectBack } = location.state || {};

  const [reconcileModal, setReconcileModal] = useState(false);
  const [reconcileData, setReconcileData] = useState({});

  const [leaveInfo, setLeaveInfo] = useState({});

  const checkLeaveInfo = useCallback((empID) => {
    const payload = {
      // empId: rowData.emp_id,
      empId: empID
    };
    console.log("payload", payload, rowData);
    LeaveHistoryService.getEmpInfo(payload)
      .then((resp) => {
        if (resp.data) {
          // console.log("Leave Info:", resp.data);
          setLeaveInfo(resp.data[0]);
        }
      })
      .catch((e) => console.log(e));
  }, []);

  // useEffect(() => {
  //   checkLeaveInfo();
  // }, [checkLeaveInfo]);

  const [approvedDayslist, setApprovedDayslist] = useState([]);

  const fetchEmpLeaveDays = useCallback(() => {
    const payload = {
      requestId: rowData.reqid,
    };

    // console.log(payload);

    LeaveHistoryService.getReconciliationByReq(payload)
      .then((resp) => {
        if (resp.data.length > 0) {
          const data = resp.data.map((item) => ({
            ...item,
            isHalfPaid: item.isHalfPaid === "1" ? true : false
          }))
          setApprovedDayslist(data);
          checkLeaveInfo(data[0].empID)
        }
      })
      .catch((e) => console.log(e));
  }, [rowData]);

  useEffect(() => {
    fetchEmpLeaveDays();
  }, [fetchEmpLeaveDays]);


  const setIsPaid = (date) => {
    setApprovedDayslist((prev) =>
      prev.map((item) =>
        item.ldate === date
          ? { ...item, isPaid: item.isPaid ? false : true }
          : item
      )
    );
  };

   const setIsHalfPaid = (date) => {
    setApprovedDayslist((prev) =>
      prev.map((item) =>
        item.ldate === date
          ? { ...item, isHalfPaid: item.isHalfPaid ? false : true }
          : item
      )
    );
  };


  const setIsGoodwill = (date) => {
    setApprovedDayslist((prev) =>
      prev.map((item) =>
        item.ldate === date
          ? { ...item, isgoodwill: item.isgoodwill ? false : true }
          : item
      )
    );
  };

  const isGoodWillCount = approvedDayslist
    .filter((item) => item.isgoodwill)
    .reduce((sum, item) => sum + (item.ishaifDay ? 0.5 : 1), 0);
  const isApprovedCount = approvedDayslist
    .filter((item) => item.isapproved)
    .reduce((sum, item) => sum + (item.ishaifDay ? 0.5 : 1), 0);


    const handleUpdateLeaveReconcile = (data) => {
      // console.log("data", data)
      const payload = {
        rid: data.requestId.toString(),
        emp_id: data.empID,
        ispaid: data.isPaid ? "1" : "0",
        ishalfday: data.ishaifDay ? "1" : "0",
        isgoodwill: data.isgoodwill ? "1" : "0",
        ldate: moment(data.ldate, "DD-MM-YYYY").format("YYYY-MM-DD"),
        isapproved: data.isapproved ? "1" : "0",
        iscnf: data.isconfirm ? "1" : "0",
      };

      // console.log(payload);

      LeaveHistoryService.updateLeaveReconciliation(payload)
        .then((resp) => {
          if (resp.data) {
            fetchEmpLeaveDays();
            toast.success("Leave Date Revoked Successfully!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              onClose: () => {
                setReconcileModal(false);
              },
            });
          }
        })
        .catch((e) => console.log(e));
    }

  return (
    <>
      <div className="dashboard-container leaveDetails">
        <DashboardGreeting
          navHeading={navHeading}
          redirectBack={redirectBack}
          user={user}
          rowData={rowData}
        />
        <div className="filterBar mb-5">
          <ToastContainer />
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="basic-details">
              <div className="heading">
                <span>Basic Details</span>
              </div>
              <div className="leave-info mb-5">
                <div className="row mb-3">
                  <div className="col-lg-3">
                    <div className="item">
                      <div className="icon">
                        <svg
                          width="60"
                          height="60"
                          viewBox="0 0 60 60"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_123_1753)">
                            <path
                              d="M60 30C60 30.663 59.7366 31.2989 59.2678 31.7678C58.7989 32.2366 58.163 32.5 57.5 32.5C56.837 32.5 56.2011 32.2366 55.7322 31.7678C55.2634 31.2989 55 30.663 55 30C54.9927 23.3718 52.3565 17.0172 47.6696 12.3304C42.9828 7.64354 36.6282 5.00728 30 5C29.337 5 28.7011 4.73661 28.2322 4.26777C27.7634 3.79893 27.5 3.16304 27.5 2.5C27.5 1.83696 27.7634 1.20107 28.2322 0.732233C28.7011 0.263392 29.337 0 30 0C37.9539 0.0086027 45.5795 3.17207 51.2037 8.7963C56.8279 14.4205 59.9914 22.0461 60 30ZM40 32.5C40.663 32.5 41.2989 32.2366 41.7678 31.7678C42.2366 31.2989 42.5 30.663 42.5 30C42.5 29.337 42.2366 28.7011 41.7678 28.2322C41.2989 27.7634 40.663 27.5 40 27.5H34.3075C33.8718 26.7511 33.2489 26.1282 32.5 25.6925V17.5C32.5 16.837 32.2366 16.2011 31.7678 15.7322C31.2989 15.2634 30.663 15 30 15C29.337 15 28.7011 15.2634 28.2322 15.7322C27.7634 16.2011 27.5 16.837 27.5 17.5V25.6925C26.8369 26.0743 26.2706 26.6036 25.845 27.2394C25.4194 27.8752 25.1458 28.6005 25.0455 29.359C24.9452 30.1175 25.0208 30.8889 25.2665 31.6135C25.5123 32.3381 25.9215 32.9964 26.4625 33.5375C27.0036 34.0785 27.6619 34.4877 28.3865 34.7335C29.1111 34.9792 29.8825 35.0548 30.641 34.9545C31.3995 34.8542 32.1248 34.5806 32.7606 34.155C33.3964 33.7294 33.9257 33.1631 34.3075 32.5H40ZM4.5675 16.96C4.07305 16.96 3.5897 17.1066 3.17858 17.3813C2.76745 17.656 2.44702 18.0465 2.2578 18.5033C2.06858 18.9601 2.01907 19.4628 2.11554 19.9477C2.212 20.4327 2.4501 20.8781 2.79973 21.2278C3.14937 21.5774 3.59482 21.8155 4.07978 21.912C4.56473 22.0084 5.06739 21.9589 5.52421 21.7697C5.98103 21.5805 6.37147 21.26 6.64618 20.8489C6.92088 20.4378 7.0675 19.9545 7.0675 19.46C7.0675 18.797 6.80411 18.1611 6.33527 17.6922C5.86643 17.2234 5.23054 16.96 4.5675 16.96ZM5 30C5 29.5055 4.85338 29.0222 4.57868 28.6111C4.30397 28.2 3.91352 27.8795 3.45671 27.6903C2.99989 27.5011 2.49723 27.4516 2.01228 27.548C1.52732 27.6445 1.08187 27.8826 0.732234 28.2322C0.382603 28.5819 0.144501 29.0273 0.0480379 29.5123C-0.0484251 29.9972 0.0010832 30.4999 0.190302 30.9567C0.379521 31.4135 0.699953 31.804 1.11108 32.0787C1.5222 32.3534 2.00555 32.5 2.5 32.5C3.16304 32.5 3.79893 32.2366 4.26777 31.7678C4.73661 31.2989 5 30.663 5 30ZM30 55C29.5055 55 29.0222 55.1466 28.6111 55.4213C28.2 55.696 27.8795 56.0865 27.6903 56.5433C27.5011 57.0001 27.4516 57.5028 27.548 57.9877C27.6445 58.4727 27.8826 58.9181 28.2322 59.2678C28.5819 59.6174 29.0273 59.8555 29.5123 59.952C29.9972 60.0484 30.4999 59.9989 30.9567 59.8097C31.4135 59.6205 31.804 59.3 32.0787 58.8889C32.3534 58.4778 32.5 57.9945 32.5 57.5C32.5 56.837 32.2366 56.2011 31.7678 55.7322C31.2989 55.2634 30.663 55 30 55ZM10.5525 8.0175C10.058 8.0175 9.5747 8.16412 9.16358 8.43883C8.75245 8.71353 8.43202 9.10398 8.2428 9.56079C8.05358 10.0176 8.00408 10.5203 8.10054 11.0052C8.197 11.4902 8.4351 11.9356 8.78473 12.2853C9.13437 12.6349 9.57982 12.873 10.0648 12.9695C10.5497 13.0659 11.0524 13.0164 11.5092 12.8272C11.966 12.638 12.3565 12.3175 12.6312 11.9064C12.9059 11.4953 13.0525 11.012 13.0525 10.5175C13.0525 9.85446 12.7891 9.21857 12.3203 8.74973C11.8514 8.28089 11.2155 8.0175 10.5525 8.0175ZM19.4475 2.1025C18.953 2.1025 18.4697 2.24912 18.0586 2.52383C17.6475 2.79853 17.327 3.18898 17.1378 3.64579C16.9486 4.10261 16.8991 4.60527 16.9955 5.09023C17.092 5.57518 17.3301 6.02064 17.6797 6.37027C18.0294 6.7199 18.4748 6.958 18.9598 7.05446C19.4447 7.15093 19.9474 7.10142 20.4042 6.9122C20.861 6.72298 21.2515 6.40255 21.5262 5.99143C21.8009 5.5803 21.9475 5.09695 21.9475 4.6025C21.9475 3.93946 21.6841 3.30357 21.2153 2.83473C20.7464 2.36589 20.1105 2.1025 19.4475 2.1025ZM4.5675 38.04C4.07305 38.04 3.5897 38.1866 3.17858 38.4613C2.76745 38.736 2.44702 39.1265 2.2578 39.5833C2.06858 40.0401 2.01907 40.5428 2.11554 41.0277C2.212 41.5127 2.4501 41.9581 2.79973 42.3078C3.14937 42.6574 3.59482 42.8955 4.07978 42.992C4.56473 43.0884 5.06739 43.0389 5.52421 42.8497C5.98103 42.6605 6.37147 42.34 6.64618 41.9289C6.92088 41.5178 7.0675 41.0345 7.0675 40.54C7.0675 39.877 6.80411 39.2411 6.33527 38.7722C5.86643 38.3034 5.23054 38.04 4.5675 38.04ZM10.5525 46.9825C10.058 46.9825 9.5747 47.1291 9.16358 47.4038C8.75245 47.6785 8.43202 48.069 8.2428 48.5258C8.05358 48.9826 8.00408 49.4853 8.10054 49.9702C8.197 50.4552 8.4351 50.9006 8.78473 51.2503C9.13437 51.5999 9.57982 51.838 10.0648 51.9345C10.5497 52.0309 11.0524 51.9814 11.5092 51.7922C11.966 51.603 12.3565 51.2825 12.6312 50.8714C12.9059 50.4603 13.0525 49.977 13.0525 49.4825C13.0525 48.8195 12.7891 48.1836 12.3203 47.7147C11.8514 47.2459 11.2155 46.9825 10.5525 46.9825ZM19.4475 52.8975C18.953 52.8975 18.4697 53.0441 18.0586 53.3188C17.6475 53.5935 17.327 53.984 17.1378 54.4408C16.9486 54.8976 16.8991 55.4003 16.9955 55.8852C17.092 56.3702 17.3301 56.8156 17.6797 57.1653C18.0294 57.5149 18.4748 57.753 18.9598 57.8495C19.4447 57.9459 19.9474 57.8964 20.4042 57.7072C20.861 57.518 21.2515 57.1976 21.5262 56.7864C21.8009 56.3753 21.9475 55.892 21.9475 55.3975C21.9475 54.7345 21.6841 54.0986 21.2153 53.6297C20.7464 53.1609 20.1105 52.8975 19.4475 52.8975ZM55.4325 38.04C54.938 38.04 54.4547 38.1866 54.0436 38.4613C53.6325 38.736 53.312 39.1265 53.1228 39.5833C52.9336 40.0401 52.8841 40.5428 52.9805 41.0277C53.077 41.5127 53.3151 41.9581 53.6647 42.3078C54.0144 42.6574 54.4598 42.8955 54.9448 42.992C55.4297 43.0884 55.9324 43.0389 56.3892 42.8497C56.846 42.6605 57.2365 42.34 57.5112 41.9289C57.7859 41.5178 57.9325 41.0345 57.9325 40.54C57.9325 40.2117 57.8678 39.8866 57.7422 39.5833C57.6166 39.28 57.4324 39.0044 57.2003 38.7722C56.9681 38.5401 56.6925 38.3559 56.3892 38.2303C56.0859 38.1047 55.7608 38.04 55.4325 38.04ZM49.4475 46.9825C48.953 46.9825 48.4697 47.1291 48.0586 47.4038C47.6475 47.6785 47.327 48.069 47.1378 48.5258C46.9486 48.9826 46.8991 49.4853 46.9955 49.9702C47.092 50.4552 47.3301 50.9006 47.6797 51.2503C48.0294 51.5999 48.4748 51.838 48.9598 51.9345C49.4447 52.0309 49.9474 51.9814 50.4042 51.7922C50.861 51.603 51.2515 51.2825 51.5262 50.8714C51.8009 50.4603 51.9475 49.977 51.9475 49.4825C51.9475 49.1542 51.8828 48.8291 51.7572 48.5258C51.6316 48.2225 51.4474 47.9469 51.2153 47.7147C50.9831 47.4826 50.7075 47.2984 50.4042 47.1728C50.1009 47.0472 49.7758 46.9825 49.4475 46.9825ZM40.5525 52.8975C40.058 52.8975 39.5747 53.0441 39.1636 53.3188C38.7525 53.5935 38.432 53.984 38.2428 54.4408C38.0536 54.8976 38.0041 55.4003 38.1005 55.8852C38.197 56.3702 38.4351 56.8156 38.7847 57.1653C39.1344 57.5149 39.5798 57.753 40.0648 57.8495C40.5497 57.9459 41.0524 57.8964 41.5092 57.7072C41.966 57.518 42.3565 57.1976 42.6312 56.7864C42.9059 56.3753 43.0525 55.892 43.0525 55.3975C43.0525 55.0692 42.9878 54.7441 42.8622 54.4408C42.7366 54.1375 42.5524 53.8619 42.3203 53.6297C42.0881 53.3976 41.8125 53.2134 41.5092 53.0878C41.2059 52.9622 40.8808 52.8975 40.5525 52.8975Z"
                              fill="#0EB9D7"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_123_1753">
                              <rect width="60" height="60" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className="info flex">
                        <div className="type">
                          <span>From</span>
                        </div>
                        <div className="content">
                          <span>
                            {moment(
                              rowData && rowData.fromDate,
                              "DD-MM-YYYY",
                            ).format("D MMMM, YYYY")}
                          </span>
                          <small>
                            {rowData.fDatehalfday === "1" ? "Half Day" : ""}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="duration">
                      <div className="dotted-line">
                        <svg
                          width="100%"
                          height="2"
                          viewBox="0 0 461 2"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M461 1L-1.66893e-05 1"
                            stroke="url(#paint0_linear_123_1778)"
                            strokeWidth="2"
                            strokeDasharray="5 5"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_123_1778"
                              x1="0"
                              y1="0.5"
                              x2="461"
                              y2="0.5"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#3B82F6" />
                              <stop offset="1" stopColor="#EF0B0B" />
                            </linearGradient>
                          </defs>
                        </svg>
                      </div>
                      <div className="">
                        <span>{rowData.leaveDays} Day</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="item">
                      <div className="icon">
                        <svg
                          width="60"
                          height="61"
                          viewBox="0 0 60 61"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_123_1747)">
                            <path
                              d="M60 30.5C60 38.4565 56.8393 46.0871 51.2132 51.7132C45.5871 57.3393 37.9565 60.5 30 60.5C22.0435 60.5 14.4129 57.3393 8.7868 51.7132C3.16071 46.0871 0 38.4565 0 30.5C0 29.837 0.263392 29.2011 0.732233 28.7322C1.20107 28.2634 1.83696 28 2.5 28C3.16304 28 3.79893 28.2634 4.26777 28.7322C4.73661 29.2011 5 29.837 5 30.5C5 35.4445 6.46622 40.278 9.21326 44.3893C11.9603 48.5005 15.8648 51.7048 20.4329 53.597C25.0011 55.4892 30.0277 55.9843 34.8773 55.0196C39.7268 54.055 44.1814 51.674 47.6777 48.1777C51.174 44.6814 53.555 40.2268 54.5196 35.3773C55.4843 30.5277 54.9892 25.5011 53.097 20.9329C51.2048 16.3648 48.0005 12.4603 43.8893 9.71326C39.778 6.96622 34.9445 5.5 30 5.5C29.337 5.5 28.7011 5.23661 28.2322 4.76777C27.7634 4.29893 27.5 3.66304 27.5 3C27.5 2.33696 27.7634 1.70107 28.2322 1.23223C28.7011 0.763392 29.337 0.5 30 0.5C37.9539 0.508603 45.5795 3.67207 51.2037 9.2963C56.8279 14.9205 59.9914 22.5461 60 30.5ZM25.6925 28H20C19.337 28 18.7011 28.2634 18.2322 28.7322C17.7634 29.2011 17.5 29.837 17.5 30.5C17.5 31.163 17.7634 31.7989 18.2322 32.2678C18.7011 32.7366 19.337 33 20 33H25.6925C26.0743 33.6631 26.6036 34.2294 27.2394 34.655C27.8752 35.0806 28.6005 35.3542 29.359 35.4545C30.1175 35.5548 30.8889 35.4792 31.6135 35.2335C32.3381 34.9877 32.9964 34.5785 33.5375 34.0375C34.0785 33.4964 34.4877 32.8381 34.7335 32.1135C34.9792 31.3889 35.0548 30.6175 34.9545 29.859C34.8542 29.1005 34.5806 28.3752 34.155 27.7394C33.7294 27.1036 33.1631 26.5743 32.5 26.1925V18C32.5 17.337 32.2366 16.7011 31.7678 16.2322C31.2989 15.7634 30.663 15.5 30 15.5C29.337 15.5 28.7011 15.7634 28.2322 16.2322C27.7634 16.7011 27.5 17.337 27.5 18V26.1925C26.7511 26.6282 26.1282 27.2511 25.6925 28ZM4.5675 22.46C5.06195 22.46 5.5453 22.3134 5.95643 22.0387C6.36755 21.764 6.68798 21.3735 6.8772 20.9167C7.06642 20.4599 7.11593 19.9572 7.01946 19.4723C6.923 18.9873 6.6849 18.5419 6.33527 18.1922C5.98564 17.8426 5.54018 17.6045 5.05523 17.508C4.57027 17.4116 4.06761 17.4611 3.61079 17.6503C3.15398 17.8395 2.76353 18.16 2.48883 18.5711C2.21412 18.9822 2.0675 19.4655 2.0675 19.96C2.0675 20.623 2.33089 21.2589 2.79973 21.7278C3.26857 22.1966 3.90446 22.46 4.5675 22.46ZM10.5525 13.5175C11.047 13.5175 11.5303 13.3709 11.9414 13.0962C12.3525 12.8215 12.673 12.431 12.8622 11.9742C13.0514 11.5174 13.1009 11.0147 13.0045 10.5298C12.908 10.0448 12.6699 9.59936 12.3203 9.24973C11.9706 8.9001 11.5252 8.662 11.0402 8.56554C10.5553 8.46907 10.0526 8.51858 9.59579 8.7078C9.13898 8.89702 8.74853 9.21745 8.47383 9.62857C8.19912 10.0397 8.0525 10.523 8.0525 11.0175C8.0525 11.6805 8.31589 12.3164 8.78473 12.7853C9.25357 13.2541 9.88946 13.5175 10.5525 13.5175ZM19.4475 7.6025C19.942 7.6025 20.4253 7.45588 20.8364 7.18117C21.2475 6.90647 21.568 6.51602 21.7572 6.05921C21.9464 5.60239 21.9959 5.09973 21.8995 4.61477C21.803 4.12982 21.5649 3.68436 21.2153 3.33473C20.8656 2.9851 20.4202 2.747 19.9352 2.65054C19.4503 2.55407 18.9476 2.60358 18.4908 2.7928C18.034 2.98202 17.6435 3.30245 17.3688 3.71357C17.0941 4.1247 16.9475 4.60805 16.9475 5.1025C16.9475 5.76554 17.2109 6.40143 17.6797 6.87027C18.1486 7.33911 18.7845 7.6025 19.4475 7.6025Z"
                              fill="#F63C3C"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_123_1747">
                              <rect
                                width="60"
                                height="60"
                                fill="white"
                                transform="translate(0 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className="info">
                        <div className="type">
                          <span>To</span>
                        </div>
                        <div className="content">
                          <span>
                            {moment(rowData.toDate, "DD-MM-YYYY").format(
                              "D MMMM, YYYY",
                            )}
                          </span>
                          <small>
                            {rowData.tDatehalfday === "1" ? "Half Day" : ""}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {leaveInfo && leaveInfo.isprobationsts !== "1" ? (
                  <>
                    <div className="balance flex-column justify-content-start mb-3">
                      <div className="left">
                        <span>Leave Balance</span>
                      </div>
                      <div className="right flex-row">
                        {/* <div className="flex">
                        <span>Monthly:</span>
                        <span className="count">01</span>
                      </div> */}
                        <div className="flex">
                          <span>Quarterly:</span>
                          <span className="count">
                            {leaveInfo.queterlyBalanceLeave}
                          </span>
                        </div>
                        <div className="flex">
                          <span>Yearly:</span>
                          <span className="count">
                            {leaveInfo.yearlyBalanceLeave}
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}

                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Half Day</th>
                      <th>Paid</th>
                      <th>Half Paid</th>
                      <th>Goodwill</th>
                      <th>Approved</th>
                      <th>Confirmed</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(approvedDayslist)
                      ? approvedDayslist.map((item) => {
                          return (
                            <tr key={item.ldate}>
                              <th>{item.ldate}</th>

                              <td>{item.ishaifDay ? "Yes" : "No"}</td>
                              <td>
                                {item.isValidLeave === 0 ? (
                                  <>
                                    <input
                                      type="checkbox"
                                      onChange={() => setIsPaid(item.ldate)}
                                      checked={item.isPaid}
                                    />
                                  </>
                                ) : (
                                  <>
                                    {item.isPaid ? (
                                      <>
                                        <button
                                          className="circle present transparent"
                                          title="Available"
                                        ></button>
                                      </>
                                    ) : null}
                                  </>
                                )}
                              </td>
                              <td>
                                {item.isValidLeave === 0 ? (
                                  <>
                                    <input
                                      type="checkbox"
                                      onChange={() => setIsHalfPaid(item.ldate)}
                                      checked={item.isHalfPaid}
                                    />
                                  </>
                                ) : (
                                  <>
                                    {item.isHalfPaid ? (
                                      <>
                                        <button
                                          className="circle present transparent"
                                          title="Available"
                                        ></button>
                                      </>
                                    ) : null}
                                  </>
                                )}
                              </td>

                              <td>
                                {item.isValidLeave === 0 ? (
                                  <>
                                    <input
                                      type="checkbox"
                                      onChange={() => setIsGoodwill(item.ldate)}
                                      checked={item.isgoodwill}
                                    />
                                  </>
                                ) : (
                                  <>
                                    {item.isgoodwill ? (
                                      <>
                                        <button
                                          className="circle present transparent"
                                          title="Available"
                                        ></button>
                                      </>
                                    ) : null}
                                  </>
                                )}
                              </td>
                              <td>
                                {item.isapproved ? (
                                  <>
                                    {" "}
                                    <button
                                      className="circle present transparent"
                                      title="Available"
                                    ></button>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </td>
                              <td>
                                {item.isconfirm ? (
                                  <>
                                    {" "}
                                    <button
                                      className="circle present transparent"
                                      title="Available"
                                    ></button>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </td>
                              <td>
                                {item.isValidLeave === 0 ? (
                                  <>
                                    <button
                                      className="btn btn-outline-primary"
                                      onClick={() => {
                                        setReconcileModal(true);
                                        setReconcileData(item);
                                      }}
                                    >
                                      Update
                                    </button>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      : null}
                  </tbody>
                  <tfoot>
                    <tr>
                      <th>Total</th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th>{isGoodWillCount}</th>
                      <th>{isApprovedCount}</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`${reconcileModal ? "modal-overlay" : ""}`}
          onClick={() => {
            setReconcileModal(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div
              className={`${
                reconcileModal ? "deleteModal visible" : "deleteModal hidden"
              }`}
            >
              <div className="flex">
                <div className="icon">
                  <img src={WarningIcon} alt="" />
                </div>
                <div className="content">
                  <span className="heading">
                    Are you sure you want to update selected leave data !
                  </span>
                </div>
              </div>
              <div className="action">
                <span
                  className="cancel"
                  onClick={(e) => {
                    setReconcileModal(false);
                  }}
                >
                  Cancel
                </span>
                <span
                  className="delete"
                  onClick={() => {
                    handleUpdateLeaveReconcile(reconcileData);
                  }}
                >
                  Update
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveReconcileDetails;
